import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CustomInputClaro from '../../forms/CustomInputClaro';
import RadiogroupClaro from '../../forms/RadioGroupClaro';
import ExpirationDateClaro from '../../forms/ExpirationDateClaro';
import InlineSelectClaro from '../../forms/InlineSelectClaro';
import ButtonsRentForm from '../../payment/commons/ButtonsRentForm';
import { converter } from '../../../helpers/converter';
import FormValidations from '../../../data/FormValidations';
import * as actions from '../../../actions/response';
import RequestManager from '../../../requests/RequestManager';
import PaywayChangePaymentMethodTask from '../../../requests/tasks/user/PaywayChangePaymentMethodTask';

export class PaymentEditCreditCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      errors: {},
      loading: false,
    };
    this.validateForm = this.validateForm.bind(this);
    this.setFormState = this.setFormState.bind(this);
  }

  setFormState(event) {
    this.state.form[event.target.name] = event.target.value;
    return this.setState(prevState => ({ form: prevState.form }));
  }

  isValidForm() {
    let formValid = true;
    this.state.errors = {};

    // Validaciones del campo nombre de tarjeta
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.name, 'name')
        .validateMinLongitude(
          1,
          converter.convertApaUnicode(
            this.props.translations,
            'error_nombre_vacio',
          ),
        )
        .validateNameFormat(
          converter.convertApaUnicode(
            this.props.translations,
            'invalid_cc_holder',
          ),
        )
        .getErrors(),
    );

    // Validaciones para el campo empresa
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.cardType, 'cardType')
        .isEqualTo(
          0,
          converter.convertApaUnicode(
            this.props.translations,
            'invalid_cc_type',
          ),
        )
        .getErrors(),
    );

    // Validaciones del campo numero de tarjeta
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.cardNumber, 'cardNumber')
        .validateMinLongitude(
          15,
          converter.convertApaUnicode(
            this.props.translations,
            'invalid_cc_number',
          ),
        )
        .validateMaxLongitude(
          16,
          converter.convertApaUnicode(
            this.props.translations,
            'invalid_cc_number',
          ),
        )
        .validateNumberFormat(
          converter.convertApaUnicode(
            this.props.translations,
            'invalid_cc_number',
          ),
        )
        .getErrors(),
    );

    // Validaciones del campo numero de seguridad
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.securityCode, 'securityCode')
        .validateMinLongitude(
          3,
          'El campo codigo de seguridad debe ser de 3 o 4 digitos',
        )
        .validateMaxLongitude(
          4,
          'El campo codigo de seguridad debe ser de 3 o 4 digitos',
        )
        .validateNumberFormat(
          'El campo codigo de seguridad debe ser de 3 o 4 digitos',
        )
        .getErrors(),
    );

    // validaciones del campo fecha de expiración
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.expiryDate_MM, 'expiryDate_MM')
        .isEqualTo(
          '',
          converter.convertApaUnicode(
            this.props.translations,
            'error_fecha_invalida_tc',
          ),
        )
        .getErrors(),
    );

    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.expiryDate_YY, 'expiryDate_YY')
        .isEqualTo(
          '',
          converter.convertApaUnicode(
            this.props.translations,
            'error_fecha_invalida_tc',
          ),
        )
        .getErrors(),
    );

    // Validaciones del campo direccion
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.address, 'address')
        .validateMinLongitude(
          1,
          converter.convertApaUnicode(
            this.props.translations,
            'error_direccion_vacia',
          ),
        )
        .getErrors(),
    );

    // Validaciones del campo ciudad
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.city, 'city')
        .validateMinLongitude(
          1,
          converter.convertApaUnicode(
            this.props.translations,
            'error_ciudad_vacia',
          ),
        )
        .validateNameFormat('Utiliza solo letras')
        .getErrors(),
    );

    // Validaciones del campo estado
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.states, 'states')
        .isEqualTo(
          '',
          converter.convertApaUnicode(
            this.props.translations,
            'error_estado_vacio',
          ),
        )
        .getErrors(),
    );

    // Validaciones del campo codigo postal
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.zipCode, 'zipCode')
        .validateMinLongitude(
          1,
          converter.convertApaUnicode(
            this.props.translations,
            'error_cp_vacio',
          ),
        )
        .validateNumberFormat('Utiliza solo numeros')
        .getErrors(),
    );

    // Validaciones del campo telefono
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.telefono, 'telefono')
        .validateMinLongitude(
          1,
          converter.convertApaUnicode(
            this.props.translations,
            'error_telefono_vacio',
          ),
        )
        .validateNumberFormat('El telefono debe tener 10 digitos')
        .getErrors(),
    );

    if (Object.keys(this.state.errors).length !== 0) {
      formValid = false;
    }
    // TODO: REFACTOR -> No atualizar el estado haciendo una lectura del mismo.
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ errors: this.state.errors });
    return formValid;
  }

  getModal(msg, modalType, onAccept) {
    const modal = {
      modalType,
      props: {
        message: msg,
        onAccept,
      },
    };
    return modal;
  }

  onSuccess(data) {
    let modal = null;
    const onAccept = null;
    let msg = null;
    let modalType = null;

    this.setState({ loading: false });

    if (data.response.status === 'error') {
      msg = data.response.msgDetail;
      modalType = 'ErrorSimple';
    }

    if (data.response.status === 'success') {
      msg = data.response.msgDetail;
      modalType = 'SuccessSimple';
      this.props.updateData();
    }

    modal = this.getModal(msg, modalType, onAccept);
    this.props.showModal(modal);
  }

  onFailed() {
    this.setState({ loading: false });
  }

  sendRequest() {
    this.setState({ loading: true });
    const request = new PaywayChangePaymentMethodTask(
      this.props.config,
      this.state.form,
    );
    RequestManager.addRequest(request)
      .then(this.onSuccess.bind(this))
      .catch(this.onFailed.bind(this));
  }

  validateForm(event) {
    event.preventDefault();
    if (!this.isValidForm()) {
      return;
    }
    this.sendRequest();
  }

  componentDidMount() {
    const form = {
      payway: 'plazavipgate',
      name: this.props.formValues.name,
      cardNumber: this.props.formValues.cardNumber,
      securityCode: this.props.formValues.securityCode,
      address: this.props.formValues.address,
      city: this.props.formValues.city,
      states: this.props.formValues.states,
      zipCode: this.props.formValues.zipCode,
      telefono: this.props.formValues.telefono,
      cardType: this.props.formValues.cardType,
      expiryDate_MM: this.props.formValues.expiryDate_MM,
      expiryDate_YY: this.props.formValues.expiryDate_YY,
    };

    this.setState({ form });
  }

  render() {
    return (
      <div className="modificar-mp">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <p>Edita los datos correspondientes a tu tarjeta de crédito</p>
          </div>
        </div>
        <div className="form-container padding-1 row padding-top-2">
          <form
            className="form-horizontal form-tarjeta row"
            id="cambiar-tarjeta"
          >
            {/* Columna 1 */}
            <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
              <CustomInputClaro
                idElement="name"
                labelText="Nombre que figura en la tarjeta"
                inputType="text"
                placeholderText="Nombre que figura en la tarjeta"
                componentClassName="form-group"
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.name}
                error={this.state.errors.name}
              />
              <RadiogroupClaro
                idElement="cardType"
                labelText={converter.convertApaUnicode(
                  this.props.translations,
                  'suscripcion_empresa_tc',
                )}
                componentWrapperClassName="form-group"
                labelClassName="col-lg-4 col-md-5 col-sm-2 col-xs-12 control-label"
                childrenClassName="col-lg-8 col-md-7 col-sm-10 col-xs-12"
                error={this.state.errors.cardType}
              >
                <label className="radio-inline">
                  <input
                    name="cardType"
                    type="radio"
                    value="1"
                    checked={this.state.form.cardType == '1'}
                    onChange={this.setFormState}
                  />
                </label>
                <img
                  width="40"
                  alt="card1"
                  src="http://www.clarovideo.com/fe/sitesplus/sk_telmex/images/tarjeta_1.png"
                />
                <label className="radio-inline">
                  <input
                    name="cardType"
                    type="radio"
                    value="2"
                    checked={this.state.form.cardType == '2'}
                    onChange={this.setFormState}
                  />
                </label>
                <img
                  alt="card4"
                  width="40"
                  src="http://www.clarovideo.com/fe/sitesplus/sk_telmex/images/tarjeta_4.png"
                />
                <span
                  data-form-validation="required"
                  className="help-block hide"
                >
                  Debes completar el campo
                </span>
              </RadiogroupClaro>
              <CustomInputClaro
                idElement="cardNumber"
                labelText="Número*"
                inputType="text"
                placeholderText="Número"
                componentClassName="form-group"
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.cardNumber}
                error={this.state.errors.cardNumber}
              />
              <CustomInputClaro
                idElement="securityCode"
                labelText="Código de Seguridad *"
                inputType="password"
                placeholderText="Código de Seguridad"
                componentClassName="form-group"
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.securityCode}
                error={this.state.errors.securityCode}
              />
              <ExpirationDateClaro
                idElement="expire_date"
                labelText={converter.convertApaUnicode(
                  this.props.translations,
                  'suscripcion_tc_fecha_expiracion',
                )}
                labelClassName="col-lg-4 col-md-5 col-sm-4 col-xs-12 control-label"
                monthDivClassName="date-mm col-lg-3 col-md-3 col-sm-4 col-xs-6"
                yearDivClassName="date-yy col-lg-5 col-md-4 col-sm-4 col-xs-6"
                errorDivClassName="help-block"
                onChange={this.setFormState}
                valueM={this.state.form.expiryDate_MM}
                valueY={this.state.form.expiryDate_YY}
                errors={[
                  this.state.errors.expiryDate_MM,
                  this.state.errors.expiryDate_YY,
                ]}
              />
              <CustomInputClaro
                idElement="address"
                labelText="Dirección *"
                inputType="text"
                placeholderText="Dirección"
                componentClassName="form-group"
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.address}
                error={this.state.errors.address}
              />
            </div>
            {/* Fin Columna 1 */}
            {/* Columna 2 */}
            <div className="col-lg-5 col-lg-offset-1 col-md-5 col-md-offset-1 col-sm-12 col-xs-12">
              <CustomInputClaro
                idElement="city"
                labelText="Ciudad *"
                inputType="text"
                placeholderText="Ciudad"
                componentClassName="form-group"
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.city}
                error={this.state.errors.city}
              />
              <InlineSelectClaro
                idElement="state"
                elements={this.props.states}
                defaultOptionText={converter
                  .convertApaUnicode(
                    this.props.translations,
                    'suscripcion_estado',
                  )
                  .replace(/\*/g, '')}
                labelText={converter.convertApaUnicode(
                  this.props.translations,
                  'suscripcion_estado',
                )}
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                comboClassName="date-mm col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.states}
                error={this.state.errors.states}
              />
              <CustomInputClaro
                idElement="zipCode"
                labelText="Código Postal *"
                inputType="text"
                placeholderText="Código Postal"
                componentClassName="form-group"
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.zipCode}
                error={this.state.errors.zipCode}
              />
              <CustomInputClaro
                idElement="telefono"
                labelText="Teléfono *"
                inputType="text"
                placeholderText="Teléfono"
                additionalMessage="Este teléfono es de contacto para la validación de tu tarjeta de crédito"
                componentClassName="form-group"
                labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
                inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
                onChange={this.setFormState}
                value={this.state.form.telefono}
                error={this.state.errors.telefono}
              />
              <div className="padding-top-1">
                <span>
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'suscripcion_detalle_campos_obligatorios',
                  )}
                </span>
              </div>
            </div>
            {/* Fin Columna 2 */}
            <div className="row">
              <div className="col-lg-4 col-lg-offset-8 col-md-4 col-md-offset-8 col-sm-12 col-xs-12">
                {this.state.loading ? (
                  <span id="cargando" className="full-width padding-2">
                    <img
                      alt=""
                      width="54"
                      className="center-block"
                      src="https://www.clarovideo.com/fe/sitesplus/sk_core/images/cargando.gif"
                    />
                  </span>
                ) : (
                  <ButtonsRentForm
                    buttonsRentBlockClassName="row"
                    loadingBlockClassName="col-lg-4 col-md-4 col-sm-12 col-xs-12"
                    backBlockClassName="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                    confirmBlockClassName="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                    translations={this.props.translations}
                    onClickConfirm={this.validateForm}
                    onClickBack={this.props.changeToViewMode}
                  />
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

PaymentEditCreditCard.propTypes = {
  translations: PropTypes.shape({}),
  changeToViewMode: PropTypes.func,
  formValues: PropTypes.shape({
    name: PropTypes.string,
    cardNumber: PropTypes.string,
    securityCode: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    states: PropTypes.string,
    zipCode: PropTypes.string,
    telefono: PropTypes.string,
    cardType: PropTypes.string,
    expiryDate_MM: PropTypes.string,
    expiryDate_YY: PropTypes.string,
  }),
  config: PropTypes.shape({}),
  states: PropTypes.shape({}),
  updateData: PropTypes.func,
  showModal: PropTypes.func,
};

const mapStateToProps = state => ({
  translations: state.translations,
  metadata: state.metadata,
  user: state.user,
  config: state.config,
  loggedInProfile: state.user.loggedInProfile,
  payway: state.user.paywayData,
});

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  removeModal(modal) {
    dispatch(actions.removeModal(modal));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentEditCreditCard);
